export const SYNC_TIME = 500;
